import React, { FC } from 'react';
import { ActivityLogResponse } from '../../../api-http/activityLogs';
import { Box, Chip, Divider, Stack, Typography } from '@mui/material';
import { displayDistance } from '../../../util/dateTime';
import ReactJson from 'react-json-view';

interface ViewLogProps {
  log: ActivityLogResponse | null;
}

const DetailField: FC<{ label: string; value?: React.ReactNode }> = ({
  label,
  value,
}) => (
  <Box>
    <Typography
      sx={{ color: '#64748b', fontSize: 12, fontWeight: 700, mb: 0.5 }}
    >
      {label}
    </Typography>
    <Typography
      sx={{ color: '#0f172a', fontSize: 14, overflowWrap: 'anywhere' }}
    >
      {value || '—'}
    </Typography>
  </Box>
);

export const ViewLog: FC<ViewLogProps> = ({ log }) => {
  if (!log) {
    return <Typography>No Data To Display</Typography>;
  }
  return (
    <Stack spacing={2.25} sx={{ pt: 2.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Chip
          label={log.action}
          size="small"
          sx={{ bgcolor: '#eef2ff', color: '#4338ca', fontWeight: 700 }}
        />
        <Typography sx={{ color: '#64748b', fontSize: 13 }}>
          {displayDistance(log.createdAt)}
        </Typography>
      </Stack>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          gap: 2,
          p: 2,
          border: '1px solid #e2e8f0',
          borderRadius: 2,
          bgcolor: '#f8fafc',
        }}
      >
        <DetailField label="Log ID" value={log._id} />
        <DetailField label="Authored by" value={log.requestedUser?.name} />
        <DetailField label="Record type" value={log.collectionName} />
        <DetailField label="Record ID" value={log.documentId} />
        <DetailField
          label="Date & time"
          value={new Date(log.createdAt).toLocaleString()}
        />
      </Box>
      <Divider />
      <Box>
        <Typography
          sx={{ color: '#0f172a', fontSize: 14, fontWeight: 700, mb: 1 }}
        >
          Previous data
        </Typography>
        <Box
          sx={{
            p: 2,
            maxHeight: 280,
            overflow: 'auto',
            border: '1px solid #e2e8f0',
            borderRadius: 2,
            bgcolor: '#f8fafc',
          }}
        >
          <ReactJson
            src={JSON.parse(log.documentData)}
            displayDataTypes={false}
            displayObjectSize={false}
            name={false}
            indentWidth={0}
            collapsed={true}
            quotesOnKeys={false}
            style={{ backgroundColor: 'transparent', color: '#0f172a' }}
          />
        </Box>
      </Box>
    </Stack>
  );
};
